module.exports = __webpack_public_path__ + "img/1_015.0732b58c.jpg";